export const LINK_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=cz.dramox.dramox';
export const LINK_APP_STORE = 'https://apps.apple.com/cz/app/dramox-divadlo-online/id1563430137?l=cs';
